import { render, staticRenderFns } from "./SubmitForReviewDialog.vue?vue&type=template&id=42c46f24&scoped=true&"
import script from "./SubmitForReviewDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitForReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitForReviewDialog.vue?vue&type=style&index=0&id=42c46f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c46f24",
  null
  
)

export default component.exports